import React from 'react'
import moment from 'moment'
import img from '../../../../public/static/image-background/logo-v-02.png'
import bgImage from '../../../../public/static/image-background/neon_glow_stadium_bg.png'
import locales from '../../../../public/static/locales/vi.json'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau6 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const color = {
        first: '#00e5ff',   // Neon Cyan
        second: '#005fcc',  // Deep Blue
        third: '#4CAF50',   // Neon Green
        fourth: '#ffbb00',  // Gold for Finals
        text: '#ffffff',
        bg: '#030816'       // Very dark blue/black
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div id={id} className={`bg-match-mau6`} style={{ width: width, minHeight: width / 1.3, padding: `${1.6 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', backgroundColor: color.bg, position: 'relative' }}>

            {/* Background Image Overlay */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
                <Image src={bgImage} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.6 }} />
                {/* Gradient to darken the image slightly for contrast */}
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(to bottom, rgba(3,8,22,0.8) 0%, rgba(3,8,22,0.4) 50%, rgba(3,8,22,0.8) 100%)' }}></div>
            </div>

            <div style={{ width: `100%`, minHeight: `calc(${width / 1.3}px - ${3.2 * px}px)`, padding: `${px * 1.5}px ${px * 1.5}px ${px * 4.2}px ${px * 1.5}px`, position: 'relative', zIndex: 1, borderRadius: `${px * 2}px`, overflow: 'hidden' }}>

                {/* Header - Glassmorphism style */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', background: `linear-gradient(90deg, rgba(0,229,255,0.05) 0%, rgba(0,95,204,0.1) 50%, rgba(0,229,255,0.05) 100%)`, borderBottom: `1px solid rgba(0, 229, 255, 0.4)`, padding: `${px * 1.5}px`, borderRadius: `${2 * px}px`, boxShadow: `0 4px 20px rgba(0, 229, 255, 0.1), inset 0 0 10px rgba(0, 229, 255, 0.05)`, backdropFilter: 'blur(8px)' }}>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <Image src={dataSeason?.logo} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain', filter: `drop-shadow(0 0 5px rgba(255,255,255,0.8))` }} />
                    </div>
                    <div style={{ flex: 6, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <h1 style={{ textAlign: 'center', color: color.text, fontSize: `${3.5 * px}px`, textTransform: 'uppercase', letterSpacing: `${px * 0.4}px`, textShadow: `0 0 10px ${color.first}, 0 0 20px ${color.first}` }}>{dataSeason?.name}</h1>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Image src={img} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain' }} />
                    </div>
                </div>

                {/* Title */}
                <div style={{ marginTop: `${px * 3}px`, marginBottom: `${px * 4}px` }}>
                    <h1 style={{ textAlign: 'center', color: color.first, fontSize: `${5 * px}px`, textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: `${px * 0.2}px`, textShadow: `0 0 15px rgba(0,229,255,0.6)` }}>{t(titleTemplate(dataSchedules[0]?.dataGo))}</h1>
                    <h2 style={{ textTransform: 'uppercase', margin: `${px}px auto 0`, width: 'max-content', color: color.bg, backgroundColor: color.first, padding: `${px}px ${6 * px}px`, borderRadius: `${px}px`, fontSize: `${2.8 * px}px`, fontWeight: 'bold', boxShadow: `0 0 15px ${color.first}` }}>
                        {t('final')}-{t('has_3rd_place')}
                    </h2>
                </div>

                {/* Matches Grid */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: `${px * 3}px`, marginTop: `${px * 4}px`, padding: `0 ${px * 4}px` }}>
                    {dataSchedules
                        ?.find(i => i.numberRound?.numberRound === 'final')
                        ?.dataGo?.map((i, idx) => (
                            <Item key={`${idx}${new Date()}`} data={i} px={px} classCustom={`${classCustom}final`} idx={idx} width={width} color={color} isFinal={true} />
                        ))}
                    {dataSchedules
                        ?.find(i => i.numberRound?.numberRound === '3rdPlace')
                        ?.dataGo?.map((i, idx) => (
                            <Item key={`${idx}${new Date()}`} data={i} px={px} classCustom={`${classCustom}3rdPlace`} idx={idx} width={width} color={color} isFinal={false} />
                        ))}
                </div>

                {/* Sponsors */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: `${6 * px}px`, padding: `${2 * px}px`, background: 'rgba(0,0,0,0.6)', borderRadius: `${2 * px}px`, flexWrap: 'wrap', borderTop: `1px solid rgba(0,229,255,0.4)`, borderBottom: `1px solid rgba(0,229,255,0.4)`, boxShadow: `0 0 20px rgba(0,229,255,0.1)`, backdropFilter: 'blur(5px)' }}>
                        {sponsorData?.slice(0, 10)?.map((i, idx) => <Image key={idx} src={i.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain', margin: `0 ${px}px` }} />)}
                    </div>
                )}

                {/* Footer */}
                <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.5)', fontSize: `${2 * px}px`, position: 'absolute', bottom: `${px}px`, right: `${1.5 * px}px`, fontWeight: 'bold', textShadow: '0 2px 4px rgba(0,0,0,1)' }}>{window.sessionStorage.getItem('HomeUrl') || 'VSPORTS EXCLUSIVE'}</p>
            </div>
        </div>
    )
}

const Item = React.memo(
    ({ data, px, classCustom, idx, width, color, isFinal }) => {
        const { t } = useTranslation()
        const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
        let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
        let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

        const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

        let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
        let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

        let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
        let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

        return (
            <div style={{ width: `100%`, background: 'rgba(10, 20, 35, 0.85)', border: `1px solid ${isFinal ? color.fourth : color.first}`, borderRadius: `${px * 2}px`, padding: `${2 * px}px ${3 * px}px`, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', boxShadow: `0 0 25px ${isFinal ? 'rgba(255,187,0,0.15)' : 'rgba(0,229,255,0.15)'}, inset 0 0 15px ${isFinal ? 'rgba(255,187,0,0.05)' : 'rgba(0,229,255,0.05)'}`, backdropFilter: 'blur(10px)' }}>

                {/* Home Team */}
                <div style={{ flex: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <Image src={data?.homeTeam?.logo} style={{ width: `${px * 9}px`, height: `${px * 9}px`, borderRadius: '50%', objectFit: 'contain', border: `2px solid rgba(255,255,255,0.4)`, padding: `${px * 0.5}px`, backgroundColor: 'rgba(255,255,255,0.1)' }} />
                    <Name propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} isLeft={true} color={color.text} />
                </div>

                {/* Time/Score */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: `0 ${px * 2}px` }}>
                    <h2 style={{ color: isFinal ? color.fourth : color.first, textAlign: 'center', fontSize: `${2.2 * px}px`, textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: '2px', textShadow: `0 0 10px ${isFinal ? color.fourth : color.first}` }}>
                        {isFinal ? `${t('final')}` : `${t('has_3rd_place')}`}
                    </h2>
                    <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: `${1.7 * px}px`, textTransform: 'uppercase', textAlign: 'center', marginBottom: `${px * 0.5}px`, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                        {data?.stadium ? `${data?.stadium} • ` : ''}{formatDateTime(data?.dateTime, 'dateTime')}
                    </div>
                    {data?.isCompleted ? (
                        <div style={{ background: `rgba(0,0,0,0.6)`, padding: `${px * 0.5}px ${px * 3}px`, borderRadius: `${px}px`, border: `1px solid ${isFinal ? color.fourth : color.first}`, minWidth: `${px * 16}px` }}>
                            <div style={{ color: isFinal ? color.fourth : color.first, fontSize: `${4.5 * px}px`, letterSpacing: '4px', textAlign: 'center', fontWeight: 'bold', textShadow: `0 0 15px ${isFinal ? color.fourth : color.first}`, whiteSpace: 'nowrap' }}>
                                {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                                {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                                {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                                {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                            </div>
                        </div>
                    ) : (
                        <div style={{ background: `rgba(0,0,0,0.6)`, padding: `${px * 0.5}px ${px * 2.5}px`, borderRadius: `${px}px`, border: `1px solid ${isFinal ? color.fourth : color.first}` }}>
                            <div style={{ color: isFinal ? color.fourth : color.first, fontSize: `${3.5 * px}px`, letterSpacing: '2px', textAlign: 'center', fontWeight: 'bold', textShadow: `0 0 10px ${isFinal ? color.fourth : color.first}` }}>
                                {formatDateTime(data?.dateTime, 'time')}
                            </div>
                        </div>
                    )}
                    {data?.isCompleted && data?.hasPenalty && (
                        <div style={{ color: color.third, fontSize: `${1.5 * px}px`, marginTop: `${px * 0.5}px`, fontWeight: 'bold' }}>
                            (PEN: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore})
                        </div>
                    )}
                </div>

                {/* Away Team */}
                <div style={{ flex: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <Name propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} isLeft={false} color={color.text} />
                    <Image src={data?.awayTeam?.logo} style={{ width: `${px * 9}px`, height: `${px * 9}px`, borderRadius: '50%', objectFit: 'contain', border: `2px solid rgba(255,255,255,0.4)`, padding: `${px * 0.5}px`, backgroundColor: 'rgba(255,255,255,0.1)' }} />
                </div>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

const Name = React.memo(
    ({ name, px, propClass, isLeft, color }) => {
        const reSizeBasedOnWidth = () => {
            let fontSize = window && window?.getComputedStyle(document.querySelector(`.${propClass}`))?.fontSize
            if (fontSize) {
                document.querySelector(`.${propClass}`).style.fontSize = parseFloat(fontSize) - 0.2 * px + 'px'
                if (document.querySelector(`.${propClass}`).scrollHeight > document.querySelector(`.contain${propClass}`).clientHeight) {
                    reSizeBasedOnWidth()
                }
            }
        }
        const processInput = () => {
            if (document.querySelector(`.${propClass}`)) {
                document.querySelector(`.${propClass}`).innerHTML = name
                document.querySelector(`.${propClass}`).style.fontSize = px * 3 + 'px' // Default font size
                reSizeBasedOnWidth()
            }
        }

        React.useEffect(() => {
            processInput()
        }, [name])

        return (
            <div className={`contain${propClass}`} style={{ width: '100%', height: `${7 * px}px`, display: 'flex', alignItems: 'center', justifyContent: isLeft ? 'flex-start' : 'flex-end', overflow: 'hidden', padding: `0 ${px * 1.5}px` }}>
                <h2 className={propClass} style={{ color: color, textAlign: isLeft ? 'left' : 'right', textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2 }}></h2>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) && JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) && JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau6, areEqual)
